<div class="flex--column spacing--margin-bottom">
  <mat-label class="text--bold text--small">{{
    'week-registration.' + settingName | translate
  }}</mat-label>
  <mat-radio-group (change)="setValue($event)">
    <mat-radio-button
      class="text--small"
      [attr.data-test]="'advanced-setting__' + settingName + '-per-day'"
      color="primary"
      [value]="'PerDay'"
      [checked]="value === 'PerDay'"
    >
      {{ 'arrival-detail.input-mode-per-day' | translate }}
    </mat-radio-button>
    <mat-radio-button
      class="text--small"
      [attr.data-test]="'advanced-setting__' + settingName + '-per-week'"
      color="primary"
      [value]="'PerWeek'"
      [checked]="value === 'PerWeek'"
    >
      {{ 'arrival-detail.input-mode-per-week' | translate }}
    </mat-radio-button>
  </mat-radio-group>
</div>
